module.exports = __webpack_public_path__ + "img/Dunya.png";